module.exports = __webpack_public_path__ + "static/15-586ba74684c48862cb86e319721e00f6.jpg";